<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { Readable } from "svelte/store";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { onMount } from "svelte";
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from "inversify-token";
import ROOT from "../../../../../inversify.config";
import { f7 } from "framework7-svelte";
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
let accountType = "";
let specificAppId = undefined;
$: console.log('account_type_url: ', accountType, specificAppId);
$: endWorkflow = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.endWorkflow) || false;
const returnToPrev = () => {
    f7.view.main.router.back();
};
const disconnectTicketmaster = () => __awaiter(void 0, void 0, void 0, function* () {
    var _b, _c;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithTicketmasterAccount(specificAppId);
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_c = (_b = result.data) === null || _b === void 0 ? void 0 : _b.UserMessage) === null || _c === void 0 ? void 0 : _c.Content) || 'An error occurred.');
    }
});
const disconnectFacebook = () => __awaiter(void 0, void 0, void 0, function* () {
    var _d, _e;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithFacebookAccount();
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_e = (_d = result.data) === null || _d === void 0 ? void 0 : _d.UserMessage) === null || _e === void 0 ? void 0 : _e.Content) || 'An error occurred.');
    }
});
const disconnectGoogle = () => __awaiter(void 0, void 0, void 0, function* () {
    var _f, _g;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithGoogleAccount();
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_g = (_f = result.data) === null || _f === void 0 ? void 0 : _f.UserMessage) === null || _g === void 0 ? void 0 : _g.Content) || 'An error occurred.');
    }
});
const disconnectApple = () => __awaiter(void 0, void 0, void 0, function* () {
    var _h, _j;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithAppleAccount();
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_j = (_h = result.data) === null || _h === void 0 ? void 0 : _h.UserMessage) === null || _j === void 0 ? void 0 : _j.Content) || 'An error occurred.');
    }
});
const disconnectSeatGeek = () => __awaiter(void 0, void 0, void 0, function* () {
    var _k, _l;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithSeatGeekAccount(specificAppId);
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_l = (_k = result.data) === null || _k === void 0 ? void 0 : _k.UserMessage) === null || _l === void 0 ? void 0 : _l.Content) || 'An error occurred.');
    }
});
const disconnectClear = () => __awaiter(void 0, void 0, void 0, function* () {
    var _m, _o;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithClearAccount();
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_o = (_m = result.data) === null || _m === void 0 ? void 0 : _m.UserMessage) === null || _o === void 0 ? void 0 : _o.Content) || 'An error occurred.');
    }
});
const disconnectNFLID = () => __awaiter(void 0, void 0, void 0, function* () {
    var _p, _q;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithNFLIDAccount();
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_q = (_p = result.data) === null || _p === void 0 ? void 0 : _p.UserMessage) === null || _q === void 0 ? void 0 : _q.Content) || 'An error occurred.');
    }
});
const disconnectParkWhiz = () => __awaiter(void 0, void 0, void 0, function* () {
    var _r, _s;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithParkWhizAccount();
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        returnToPrev();
    }
    else {
        alert(((_s = (_r = result.data) === null || _r === void 0 ? void 0 : _r.UserMessage) === null || _s === void 0 ? void 0 : _s.Content) || 'An error occurred.');
    }
});
const disconnectAxs = () => __awaiter(void 0, void 0, void 0, function* () {
    var _t, _u;
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.unlinkWithAXSAccount(specificAppId);
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        if (endWorkflow) {
            signonManager.fireWorkflowEndEvent();
        }
        else {
            returnToPrev();
        }
    }
    else {
        alert(((_u = (_t = result.data) === null || _t === void 0 ? void 0 : _t.UserMessage) === null || _u === void 0 ? void 0 : _u.Content) || 'An error occurred.');
    }
});
const handleDisconnect = () => {
    switch (accountType) {
        case "ticketmaster":
            disconnectTicketmaster();
            return;
        case "facebook":
            disconnectFacebook();
            return;
        case "google":
            disconnectGoogle();
            return;
        case "apple":
            disconnectApple();
            return;
        case "seatgeek":
            disconnectSeatGeek();
            return;
        case "clear":
            disconnectClear();
            return;
        case "nflid":
            disconnectNFLID();
            return;
        case "parkwhiz":
            disconnectParkWhiz();
            return;
        case "axs":
            disconnectAxs();
            return;
    }
};
onMount(() => {
    setTimeout(() => {
        const path = f7.views.main.router;
        const { query } = path.currentRoute;
        accountType = query.accountType;
        specificAppId = query.specificAppId;
    }, 500);
});
</script>

<CardBase {element}>
    <div class="wrapper">
        <button class="btn btn-cancel" on:click={returnToPrev}>CANCEL</button>
        <button class="btn btn-dsiconnect" on:click={handleDisconnect}>DISCONNECT</button>
    </div>
</CardBase>
<style>.wrapper {
  display: flex;
  gap: 12px;
}

.btn {
  width: 149px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid var(--alav-s-primary);
  color: var(--alav-s-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 10px;
  margin-left: auto;
  position: relative;
  cursor:pointer;
  -webkit-user-select:none;
     -moz-user-select:none;
          user-select:none;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition-duration: 0.4s;
  -webkit-transition-duration: 0.4s; /* Safari */
}

.btn:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 8px;
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.5s;
  box-shadow: 0 0 10px 10px rgb(35, 35, 35);
}

.btn:active:after {
  box-shadow: 0 0 0 0 white;
  position: absolute;
  border-radius: 8px;
  left: 0;
  top:0;
  opacity: 1;
  transition: 0s;
}</style>